import BREAKPOINTS from './breakpoints.constants';

export type ImageSizeSet = {
  [key in keyof typeof BREAKPOINTS]?: number;
} & {
  /** (Optional) The maximum allowed width for this image size above any defined breakpoints */
  MAX?: number;
};
export type ImageSize = number | ImageSizeSet;
const IMAGE_SIZE: Record<string, ImageSize> = {
  /** Base size for images shown on tablets */
  TABLET_IMAGE: 540,

  /** Large article cards in the homepage's "Top Stories" featured article sections */
  TOP_STORIES__LARGE: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: 360,
    MD: 520,
    MAX: 640
  },
  /** Small article cards in the homepage's "Top Stories" featured article sections */
  TOP_STORIES__SMALL: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: 150,
    MD: 210,
    MAX: 260
  },

  /** Large article cards in the homepage's "Latest" (trending) featured article sections */
  TRENDING__LARGE: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: 450,
    MAX: 640
  },
  /** Small article cards in the homepage's "Latest" (trending) featured article sections */
  TRENDING__SMALL: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: 220,
    MD: 310,
    MAX: 280
  },

  /** Large (highlighted) article cards in the homepage's pillar-specific news columns */
  NEWS__LARGE: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: 280,
    LG: 430,
    MAX: 280
  },
  /** Small article cards in the homepage's pillar-specific news columns */
  NEWS__SMALL: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: 120,
    LG: 190,
    MAX: 120
  },

  /** The full-width featured image appearing at the top of a TUD+ article's detail page */
  ARTICLE_FEATURE__FULL: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: BREAKPOINTS.TABLET,
    MD: BREAKPOINTS.MD,
    LG: 870,
    XL: 930,
    MAX: 1600
  },
  /** The full-width featured image appearing at the top of a standard article's detail page */
  ARTICLE_FEATURE: {
    XS: 340,
    SM: 580,
    TABLET: 470,
    MAX: 2000
  },

  /** Large article cards in the "Recommended content" related-articles section of an article detail page */
  RELATED__LARGE: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: 320,
    MD: 460,
    LG: 500,
    XL: 600,
    MAX: 900
  },
  /** Small article cards in the "Recommended content" related-articles section of an article detail page */
  RELATED__SMALL: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: 320,
    MD: 460,
    LG: 320,
    XL: 300,
    MAX: 450
  },

  /** Article cards used in standard there-column article lists, including location/category/sector/etc list pages, and search results */
  ARTICLE_LIST: {
    XS: BREAKPOINTS.XS,
    SM: 350,
    MD: 400,
    MAX: 320
  },

  /** Larger article thumbnails, used eg on the list of articles on an author's detail page */
  ARTICLE__THUMBNAIL: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: 380,
    MD: 560,
    MAX: 380
  },

  /** Large summary cards in the on-demand content list page (the first card in the list, and every 4th card thereafter) */
  ON_DEMAND__THUMBNAIL__LARGE: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: BREAKPOINTS.TABLET,
    MAX: 400
  },
  /** Small summary cards in the on-demand content list page */
  ON_DEMAND__THUMBNAIL__SMALL: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: BREAKPOINTS.TABLET,
    MAX: 320
  },

  /** Event summary blocks on the event list page */
  EVENT_SUMMARY: {
    XS: BREAKPOINTS.XS,
    SM: BREAKPOINTS.SM,
    TABLET: BREAKPOINTS.TABLET,
    MD: 250,
    MAX: 400
  },

  /** Maximum size for images rendered via the PictureZoom component */
  PICTURE_ZOOM: 1500
};
export default IMAGE_SIZE;
